export default __webpack_public_path__ + "static/media/profileIcon.8188ccd6.png";